import { CSSObject } from '@mui/material';

const divider: CSSObject = {
  styleOverrides: {
    root: {
      borderBottomWidth: '2px'
    },
    vertical: {
      borderBottomWidth: 0,
      borderRightWidth: '2px'
    }
  }
};

export default divider;
